import styled from "styled-components"

const Directory = styled.div`
    width:80%;
    margin:0 auto;
    .detail{
        padding:20px;
        font-size:1.5em;
        font-weight:bolder;
        border-bottom:2px solid #7FCFD4 ;
        margin-bottom:30px;
    }
    @media(max-width:700px ){
        width:100%;
    }
`
export default Directory 